import "core-js/modules/es.array.map.js";
import { useEffect } from 'react';
import useForm from 'hooks/useForm';
import sortBy from 'utils/sortBy';
function sortTeams(teams) {
  return sortBy(teams.map(function (team) {
    return team.id;
  }), function (teamId) {
    return teamId;
  });
}
function checkWasAutoShareChanged(defaultValue, newValue) {
  if (defaultValue.type !== newValue.type) {
    return true;
  }
  if (newValue.type === 'teams') {
    return JSON.stringify(sortTeams(defaultValue.teams)) !== JSON.stringify(sortTeams(newValue.teams));
  }
  return false;
}
export default function usePlaylistAutoShareForm(_ref) {
  var autoShareData = _ref.autoShareData;
  var playlistAutoShareForm = useForm({
    fields: {
      /**
       * Audience with whom the playlist is auto-shared
       */
      autoShare: {
        getDefaultValue: function getDefaultValue() {
          return (autoShareData === null || autoShareData === void 0 ? void 0 : autoShareData.autoShare) || {
            type: 'null',
            teams: []
          };
        },
        getWasChanged: checkWasAutoShareChanged
      }
    }
  });
  var reset = playlistAutoShareForm.reset;
  useEffect(function () {
    if (autoShareData) {
      reset({
        keepUserValues: true
      });
    }
  }, [autoShareData, reset]);
  return playlistAutoShareForm;
}